import React from 'react';
import InfluencersHero from 'components/page-influencers/hero-section';
import StatsSection from 'components/page-influencers/stats-section';
import PartnersSection from 'components/page-influencers/partners-section';
import InfluencerStickerSlider from 'components/templates-shared/influencers_sticker_slider';
import CollabSection from 'components/page-influencers/collab-section';
import Articles from 'components/templates-shared/recent_posts';
import { numberWithCommas } from 'utils/helpers';
import Meta from 'shared/meta';

function InfluencersPage({ pageContext }) {
  const { influencer, influencerPosts } = pageContext;
  const { globalRank, countryRank, category, categoryRank, brands, country, estimatePostPriceLow, estimatePostPriceHigh, firstName, lastName, username, authenticityRate, followers, engagementRate } = influencer;


  function calculateTrueValue(total, rate) {
    let number = total * (rate);
    if (number.toFixed(0).toString().length > 6) {
      number = `${(number / 1000000).toFixed(1)}M`;
    } else if (number.toFixed(0).toString().length > 3) {
      number = `${(number / 1000).toFixed(1)}K`;
    } else {
      number = `${(number).toFixed(0)}`;
    }
    // return number.replace('.0', '');
    return number.toString().replace('.0', '');
  }

  const stickyDetails = [
    {
      title: 'GLOBAL RANK',
      category: 'Worldwide',
      value: numberWithCommas(globalRank)
    },
    {
      title: 'COUNTRY RANK',
      category: country ?.name,
      value: numberWithCommas(countryRank)
    },
    {
      title: 'CATEGORY RANK',
      category: category ?.name,
      value: numberWithCommas(categoryRank)
    }
  ];
  const parsedFirstName = firstName && firstName.replace(firstName[0], firstName[0].toUpperCase());
  const parsedLastName = lastName && lastName.replace(lastName[0], lastName[0].toUpperCase());
  const description = `${parsedFirstName} ${parsedLastName} is an influencer located in${country ?.name === 'United States' ? ' the' : ''} ${country ? country.name : 'United States'}. Has ${followers !== '' ? calculateTrueValue(followers, 1) : ''} followers with ${followers !== '' ? calculateTrueValue(followers, authenticityRate) : ''} being real and an engagement rate of ${(engagementRate * 100).toFixed(0)}% which leaves this influencer at ${followers !== '' ? calculateTrueValue(followers, engagementRate) : ''} true fans.`;
  return (
    <main>
      <Meta title={`${parsedFirstName} ${parsedLastName} @${username} | Furlough Ф Influencer`} description={description} canonical={`https://furlough.com/influencer/${username.replace('@', '')}`} />
      <InfluencersHero {...{ ...influencer, stickyDetails }} />
      <StatsSection {...{ ...influencer, stickyDetails }} />
      <PartnersSection cards={brands} />
      <CollabSection
        influencer_name={`${influencer.firstName} ${influencer.lastName}`}
        price_high={estimatePostPriceHigh}
        price_low={estimatePostPriceLow}
      />
      {influencerPosts && influencerPosts.length > 0 ? (
        <Articles articles={influencerPosts} title="as featured in" />
      ) : null}
      <InfluencerStickerSlider />
    </main>
  );
}

export default InfluencersPage;
